// This context is provided by foundations-editor-ui.

import { createContext } from 'react';

export interface SandboxContextState {
  sandboxed: boolean;
}

export const defaultSandboxContext: SandboxContextState = { sandboxed: false };

export const SandboxContext = createContext(defaultSandboxContext);

const { Consumer, Provider } = SandboxContext;

export { Provider as SandboxContextProvider };
export { Consumer as SandboxContextConsumer };
